import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../../auth/hooks/useAuth';
import { useSessionBootstrap } from '../../auth/hooks/useSessionBootstrap';
import { appPath } from '../../../routes/paths';
import MarketingLayout from './MarketingLayout';
import MarketingLandingPage from './MarketingLandingPage';

/** Public home at `/`. Signed-in users go straight to the app shell. */
const MarketingHomePage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { ready } = useSessionBootstrap();

  if (!ready) {
    return (
      <div className="cp-auth-loading">
        <Spin size="large" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={appPath()} replace />;
  }

  return (
    <MarketingLayout>
      <MarketingLandingPage />
    </MarketingLayout>
  );
};

export default MarketingHomePage;
